import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'self... Remove this comment to see the full error message

import { isPaidHub } from 'self-service-api/core/utilities/parcelUtils';
import { isPartnerProgramEligibleSelector } from 'pricing-pages-ui/selectors/PartnerProgramSelectors';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import safeLocalStorage from 'pricing-pages-lib/utils/safeLocalStorage';
import { getPartnerProgramUrl } from 'pricing-pages-lib/utils/publicPageUrls';
const BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';

const PartnerProgramBanner = () => {
  const isBannerDismissed = safeLocalStorage.getItem(BANNER_DISMISSED_KEY);
  const isPartnerProgramEligible = useSelector(isPartnerProgramEligibleSelector);
  const [shouldShowBanner, setShouldShowBanner] = useState(!isBannerDismissed && isPartnerProgramEligible);

  const closeBanner = () => {
    setShouldShowBanner(false);
    safeLocalStorage.setItem(BANNER_DISMISSED_KEY, true);
  };

  const partnerProgramLink = getPartnerProgramUrl();

  const handleClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'partner-banner-more-info',
      url: partnerProgramLink
    });
  };

  useEffect(() => {
    let isMounted = true;
    isPaidHub().then(hasPaidProduct => {
      if (isMounted) {
        setShouldShowBanner(isPartnerProgramEligible && !hasPaidProduct && !isBannerDismissed);
      }
    }).catch(error => {
      console.error(error);
      setShouldShowBanner(false);
    });
    return () => {
      isMounted = false;
    };
  }, []);
  if (!shouldShowBanner) return null;
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-selenium-id": "partner-program-banner",
    type: "info",
    closeable: true,
    onClose: closeBanner,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.promotions.partnerProgram.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "pricingPage.promotions.partnerProgram.text_jsx",
      elements: {
        UILink
      },
      options: {
        link: partnerProgramLink,
        onClick: handleClick
      }
    })
  });
};

export default PartnerProgramBanner;